// src/pages/profile/activity/liked-articles/components/VirtualList.jsx
import PropTypes from 'prop-types';

import ArticlesVirtualList from '@/pages/profile/board/components/ArticlesVirtualList';

/**
 * Liked Articles → reuse the exact same ArticlesVirtualList
 * that ProfileBoard uses for the “articles” tab.
 */
export default function VirtualList({ items, onLoadMore }) {
  return (
    <ArticlesVirtualList
      items={items}
      publishedItems={items.data}
      onLoadMore={onLoadMore}
    />
  );
}

VirtualList.propTypes = {
  items: PropTypes.shape({
    data: PropTypes.array.isRequired,
    totalDocs: PropTypes.number.isRequired
  }).isRequired,
  onLoadMore: PropTypes.func.isRequired
};
